module.exports = __webpack_public_path__ + "static/teupen-leo-d2357f51cf8a63ed36192f3760125fc8.webp";